import {
  APIAttachment,
  ApiDocumentReference,
  ArdoqId,
  DocumentReference,
} from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { DOMAIN } from 'assistant/actions';
import type { UploadError, UploadingDocument } from './types';

export const openGiveContext = actionCreator(`${DOMAIN} openGiveContext`);

export const closeGiveContext = actionCreator(`${DOMAIN} closeGiveContext`);

export const showOrgDocumentsStep = actionCreator(
  `${DOMAIN} showOrgDocumentsStep`
);

export const setDocumentSearchTerm = actionCreator<string>(
  `${DOMAIN} setDocumentSearchTerm`
);

export const loadOrgDocuments = actionCreator(`${DOMAIN} loadOrgDocuments`);

export const orgDocumentsLoaded = actionCreator<APIAttachment[]>(
  `${DOMAIN} orgDocumentsLoaded`
);

export const orgDocumentsLoadFailed = actionCreator(
  `${DOMAIN} orgDocumentsLoadFailed`
);

export const selectDocument = actionCreator<DocumentReference>(
  `${DOMAIN} selectDocument`
);

export const deselectDocument = actionCreator<ArdoqId>(
  `${DOMAIN} deselectDocument`
);

export const removeSelectedDocument = actionCreator<DocumentReference>(
  `${DOMAIN} removeSelectedDocument`
);

export const downloadDocument = actionCreator<ApiDocumentReference>(
  `${DOMAIN} downloadDocument`
);

export const uploadDocumentsFromComputer = actionCreator<File[]>(
  `${DOMAIN} uploadDocumentsFromComputer`
);

export const documentUploadStarted = actionCreator<UploadingDocument>(
  `${DOMAIN} documentUploadStarted`
);

export const documentUploadSucceeded = actionCreator<{
  uploadId: string;
  document: DocumentReference;
}>(`${DOMAIN} documentUploadSucceeded`);

export const documentUploadFailed = actionCreator<{
  uploadId: string;
  error: UploadError;
}>(`${DOMAIN} documentUploadFailed`);

export const showUploadError = actionCreator<UploadError>(
  `${DOMAIN} showUploadError`
);

export const setWebSearchEnabled = actionCreator<boolean>(
  `${DOMAIN} setWebSearchEnabled`
);
